// Dados do carrossel - hardcoded no frontend
export const carouselData = [
  {
    id: "carousel-1",
    image_url: "https://nautitours.pt/multimedia/aqua_taxi.jpg",
    title: {
      pt: "Barco para a Praia",
      en: "Boat to the Beach",
      es: "Barco a la Playa"
    },
    subtitle: null,
    order: 1,
    active: true
  },
  {
    id: "carousel-2",
    image_url: "https://nautitours.pt/multimedia/banner-sem-pressa.jpg",
    title: {
      pt: "Passeio Cultural",
      en: "Cultural Tour",
      es: "Paseo Cultural"
    },
    subtitle: {
      pt: "Historical Guided Tour",
      en: "Historical Guided Tour",
      es: "Historical Guided Tour"
    },
    order: 2,
    active: true
  },
  {
    id: "carousel-3",
    image_url: "https://nautitours.pt/multimedia/banner-2.jpg",
    title: {
      pt: "Pack Adrenalina",
      en: "Adrenaline Pack",
      es: "Pack Adrenalina"
    },
    subtitle: null,
    order: 3,
    active: true
  },
  {
    id: "carousel-4",
    image_url: "https://nautitours.pt/multimedia/banner-3.jpg",
    title: {
      pt: "Motas de Água",
      en: "Jet Skis",
      es: "Motos de Agua"
    },
    subtitle: null,
    order: 4,
    active: true
  },
  {
    id: "carousel-5",
    image_url: "https://nautitours.pt/multimedia/paddle-banner.jpg",
    title: {
      pt: "Kayak",
      en: "Kayak",
      es: "Kayak"
    },
    subtitle: null,
    order: 5,
    active: true
  }
];
